// extracted by mini-css-extract-plugin
export default {"wrapper":"MdrChoice_wrapper__G4uj2","wrapper2":"MdrChoice_wrapper2__-JhIj"};